import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { DocumentoExpedienteInventario, DocumentoInventarioExpediente} from '@app/shared';
import { promise } from 'protractor';

@Injectable()
export class DocumentExpInventoryFormDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }



  /**
   * Metodo que devuelve todos los documentos 
   *
   * @param {any} parametros
   * @return {*}  {Observable<DocumentoExpedienteInventario[]>}
   * @memberof DocumentExpInventoryFormDataService
   */
  getDocumentInventory(parametros:any): Promise<DocumentoExpedienteInventario[]> {
    return new Promise((resolve, reject) => {
        this.http.post<DocumentoExpedienteInventario[]>(this.api.get('documentExpInventorySearch'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
            },
            err => {
              reject(err);
            }
          );
      });
  }

  /**
   * Metodo que devuelve todos los documentos
   *
   * @param {any} parametros
   * @return {*}  {Observable<DocumentoInventario[]>}
   * @memberof DocumentExpInventoryFormDataService
   */
   getDocumentInventoryExp(parametros:any): Promise<DocumentoInventarioExpediente[]> {
    return new Promise((resolve, reject) => {
        this.http.post<DocumentoInventarioExpediente[]>(this.api.get('documentExpInventorySearch'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
            },
            err => {
              reject(err);
            }
          );
      });
  }

  /**
   * Metodo que devuelve las opciones para los titulos y busquedas de las tablas
   *
   * @param {any} parametros
   * @return {*}  {Observable<any[]>}
   * @memberof DocumentExpInventoryFormDataService
   */
   getDocumentInventoryExpOptions(parametros:any): Promise<any> {
    return new Promise((resolve, reject) => {
        this.http.post<any>(this.api.get('documentExpInventorySearch'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
            },
            err => {
              reject(err);
            }
          );
      });
  }

  /**
   * Metodo que devuelve la informacion del inventario
   *
   * @param {any} parametros
   * @return {*}  {Observable<any>}
   * @memberof DocumentExpInventoryFormDataService
   */
   getDocumentInventoryInfo(parametros:any): Promise<any> {
    return new Promise((resolve, reject) => {
        this.http.post<any>(this.api.get('documentInventorySearch'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
            },
            err => {
              reject(err);
            }
          );
      });
  }


    /**
   *Servicio para descargar documento
   *
   * @param {number} idDocumento
   * @return {*}  {Observable<any>}
   * @memberof DocumentExpInventoryFormDataService
   */
   dowloadFile(idDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('docsInstance', [idDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   * Metodo que devuelve todos los documentos vencidos por tarea y año
   *
   * @param {any} parametros
   * @return {*}  {Observable<DocumentoInventario[]>}
   * @memberof DocumentExpInventoryFormDataService
   */
   sendDocumentsOptionsInfo(parametros:any): Promise<boolean> {
    return new Promise((resolve, reject) => {
        this.http.post<boolean>(this.api.get('documentInventory'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
              if(parametros.tipo == "asociar_documento"){
                this.toastr.success('Asociacion realizada correctamente', 'Operación exitosa');
              }else{
                this.toastr.success('Registro realizado', 'Operación exitosa');
              }
              
            },
            err => {
              if (err.status !== 401 && err.status !== 403) {
                  if (err.status === 500) {
                      this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
                  } else {
                    if(err.status==400){
                      this.toastr.warning(err.error, 'Fallo en registro');
                    }else{
                      this.toastr.warning(err.error['message'], 'Fallo en registro');
                    }
                    
                  }
              }
              reject(err);
            }
          );
      });
  }

  /**
   * Metodo que devuelve todos los documentos vencidos por tarea y año
   *
   * @param {any} parametros
   * @return {*}  {Observable<DocumentoInventario[]>}
   * @memberof DocumentExpInventoryFormDataService
   */
   sendDocumentsInfo(parametros:any): Promise<boolean> {
    return new Promise((resolve, reject) => {
        this.http.post<boolean>(this.api.get('documentExpInventory'),
          parametros).subscribe(
            specificValues => {
              resolve(specificValues);
              if(parametros.tipo == "asociar_documento"){
                this.toastr.success('Asociacion realizada correctamente', 'Operación exitosa');
              }else{
                this.toastr.success('Registro realizado', 'Operación exitosa');
              }
              
            },
            err => {
              if (err.status !== 401 && err.status !== 403) {
                  if (err.status === 500) {
                      this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
                  } else {
                    if(err.status==400){
                      this.toastr.warning(err.error, 'Fallo en registro');
                    }else{
                      this.toastr.warning(err.error['message'], 'Fallo en registro');
                    }
                    
                  }
              }
              reject(err);
            }
          );
      });
  }

  /**
 * Consultar todas los parametros de forma especifica de tipo inventario expedientes
 *
 * @returns {Observable<any[]>}
 * @memberof DocumentExpInventoryFormDataService
 */
 getTypeFormParameters(): Observable<any[]> {
  return new Observable(obs => {
    this.http.get<any[]>(this.api.get('documentExpInventorySearch')).subscribe(
      series => {
      obs.next(series);
    },
    err => {
      obs.error(err);
    });
  });
}
}


// WEBPACK FOOTER //
// ./src/app/forms/all/document-exp-inventory-form/shared/document-exp-inventory-form.data.service.ts